var alerts = document.querySelectorAll('.ga-alert');
window._gaq = window._gaq || [];
window._gaq.push(['_setAccount', window._ppGaTrackingId || 'UA-29343964-10']);
window._gaq.push(['_trackPageview']);

(function () {
	var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
	ga.src = ('https:' === document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
	var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
})();

var ppTracking = (function () {
	var init = function () {

		// Track pixel density ratio
		var pixelRatio = window.devicePixelRatio ? String(window.devicePixelRatio) : "1";
		window._gaq.push(['_setCustomVar', 1, 'Pixel Ratio', pixelRatio, 1]);
	};

	return { init: init };
}());

document.addEventListener('DOMContentLoaded', function (event) {
	ppTracking.init();
});

if (alerts) {
	Array.prototype.forEach.call(alerts, function (el, i) {
		el.addEventListener('click', function (event) {
			window._gaq.push(['_trackEvent', document.title, el.innerText]);
		});
	});
}
